module.exports = __webpack_public_path__ + "static/media/AromaofRoses.83275065.jpg";